import styled from 'styled-components';

export const Container = styled.div`
width: 49%;
height: auto;
border: 1px solid var(--light-gray);

@media (max-width: 820px) {
  width: 100%;
  height: auto;
  margin: 0 0 25px 0;
}
`;

export const TitleCard = styled.span`
  display: flex;
  padding: .3rem;
  font-size: 1rem;
  font-weight: bold;
  color: var(--title);
  justify-content: center;
  background: var(--light-gray);
`;

export const WrapperContentCard = styled.div`
  height: auto;
  display: flex;

  @media (max-width: 820px) {
    flex-direction: column;
  }
`;

